'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var dataTypeSmallText = exports.dataTypeSmallText = 'small_text';
var dataTypeLargeText = exports.dataTypeLargeText = 'large_text';
var dataTypeBoolean = exports.dataTypeBoolean = 'boolean';
var dataTypeDateTime = exports.dataTypeDateTime = 'datetime';
var dataTypeDateOnly = exports.dataTypeDateOnly = 'dateonly';
var dataTypeReal = exports.dataTypeReal = 'real';
var dataTypeInteger = exports.dataTypeInteger = 'integer';

exports.default = {
    dataTypeSmallText: dataTypeSmallText,
    dataTypeLargeText: dataTypeLargeText,
    dataTypeBoolean: dataTypeBoolean,
    dataTypeDateTime: dataTypeDateTime,
    dataTypeDateOnly: dataTypeDateOnly,
    dataTypeReal: dataTypeReal,
    dataTypeInteger: dataTypeInteger
};